import { parse, isValidNumber } from 'libphonenumber-js';

export default (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return isValidNumber(parse(value, { country: { default: 'ZA' } }));
};



// WEBPACK FOOTER //
// ./src/utils/validators/PhoneNumber.js